import { AnimationBase, Bitmap, getText, MeterBitmap, SpineBase } from "@quest/base-core";
import { StaticSymbol, SymbolBase } from "@quest/slot-core";

export class SymbolBaseGame extends SymbolBase {
  protected createStatic(json: any): void {
    if (typeof json.staticSym.image !== "string") {
      throw new Error("Please provide a valid static image for " + json.symName);
    }
    this.staticSym = new StaticSymbol(this.symNum, json.staticSym, this.name, json.zIndex);
    if (json.overlayAnim) {
      const overlayAnimation: AnimationBase = new AnimationBase(json.overlayAnim); //, currentGame);
      this.staticSym.addChild(overlayAnimation);
    }
    if (json.staticBlurLayer) {
      for (const json1 of json.staticBlurLayer) {
        if (json1.type === "meterbitmap") {
          const meterBitmap: MeterBitmap = new MeterBitmap(json1);
          meterBitmap.setText(getText(json1.text, json1.replaceText));
          this.staticSym.addChild(meterBitmap);
        } else if (json1.type === "image") {
          const objImg: Bitmap = new Bitmap(json1);
          this.staticSym.addChild(objImg);
        }
      }
    }
  }

  protected createAnimation(json: any): void {
    super.createAnimation(json);
    if (json.overlayAnimText) {
      const overlayAnimation: SpineBase = new SpineBase(json.overlayAnimText); //
      this.animationSym.addChild(overlayAnimation);
    }
  }
}
